import React from 'react'
import { useHistory, useParams } from 'react-router-dom'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import { Column } from 'src/components/Layout/Styled'

const ClassEnd = () => {
  const { id: uuid } = useParams()
  const history = useHistory()
  return (
    <Column sx={{ my: 'auto', mx: 4, alignItems: 'center' }}>
      <Typography variant="h4" color="primary">
        สิ้นสุดระยะเวลาเรียน
      </Typography>
      <Typography
        sx={{ textAlign: 'center' }}
        variant="h4Light"
        color="primary"
      >
        ระยะเวลาที่กำหนดสำหรับการเรียนในระบบได้สิ้นสุดลงแล้ว
        กรุณากดปุ่มด้านล่างเพื่อกลับสู่หน้าหลัก
      </Typography>
      <Button
        sx={{ marginTop: 5 }}
        size="l"
        variant="contained"
        onClick={() => history.push(`/e-learning/course/${uuid}`)}
      >
        กลับสู่หน้าหลัก
      </Button>
    </Column>
  )
}

export default ClassEnd
